import { makeAutoObservable } from 'mobx'
import type { IResponseIntegrationHubspotDeal } from 'entities/Integrations'
import type { IIntegrationsProperty, IIntegrationsTicket } from 'entities/Integrations/model/types'
import { IntegrationProperty } from 'entities/Integrations/model/IntegrationProperty/IntegrationProperty'

export class IntegrationTicketProperty {
  private _id: number | null = null
  private _name: string | null = null
  private _propertiesMap: Map<string, IntegrationProperty> = new Map()

  constructor(item: IIntegrationsTicket) {
    this._id = !isNaN(Number(item.id.value)) ? Number(item.id.value) : 0
    this._name = item.subject.value
    this.addProperties(item)

    makeAutoObservable(this)
  }

  get id() {
    return this._id || 0
  }

  get title() {
    return this._name || ''
  }

  get properties() {
    return Array.from(this._propertiesMap.values())
  }

  get propertiesKeys() {
    return this.properties.map((item) => item.key)
  }

  get owner() {
    const value = this.getProperty('owner')?.value
    const first_name = this.getProperty('owner')?.first_name
    const last_name = this.getProperty('owner')?.last_name

    return {
      value: value || '',
      first_name: first_name || '',
      last_name: last_name || '',
    }
  }

  addProperties = (item: IIntegrationsTicket) => {
    Object.entries(item).forEach(([k, item]) => {
      const key = k as keyof IIntegrationsTicket

      if (key === 'subject') return
      if (key === 'id') return

      this.addProperty({
        key: key,
        label: item.label || '',
        value: item.value ? String(item.value) : '',
      })
    })
  }

  addProperty = (item: IIntegrationsProperty) => {
    this._propertiesMap.set(item.key, new IntegrationProperty(item))
  }

  removeProperty = (key: string) => {
    this._propertiesMap.delete(key)
  }

  getProperty = (key: keyof IResponseIntegrationHubspotDeal) => {
    return this._propertiesMap.get(key)
  }
}
